import isBrowserContext from "helpers/isBrowserContext";
import { useState, useEffect } from "react";

function getWindowDimensions() {
    if (isBrowserContext()) {
        const { innerWidth: width, innerHeight: height } = window;
        return { width, height };
    }
    else {
        return { width: 1024, height: 800 };
    }
}

export default (): { width: number, height: number } => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
};